import React, {Component} from 'react';
//import io from 'socket.io-client';
import Loading from "../Common/Loading";

import Actionbar from "../Common/Actionbar";

import API from "../../services/API";
import {toast} from "react-toastify";
import Toast from "../Common/Toast";

class NotifConfigs extends Component {
    state = {
        setting: '0',
        isLoaded: false,
        activeCar: window.localStorage.getItem("_ac" ),
        connection_type : window.localStorage.getItem("connection_type"),
    }


    sendToSocket = (command) => {

        const ConnectionType = window.localStorage.getItem("connection_type");
        if(ConnectionType === 'internet') {
            const request = {
                'mobile': this.state.cars[this.state.activeCar].main_phone,
                'device': this.state.cars[this.state.activeCar].car_code,
                'password': window.localStorage.getItem("password"),
                'command': command
            };
            this.setState({isLoaded: false})
            API.socketSendData(request)
                .then((response) => {
                    toast.success('دستور با موفقیت به دستگاه ارسال شد');
                    const mobile = window.localStorage.getItem("mobile");
                    const password = window.localStorage.getItem("password");

                    API.getCarData(mobile,password)
                        .then((response) => {
                            this.setState({isLoaded: true, 'cars': response.car_act})

                        })
                })

        }
        else {

            let check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            if(!check) {
                toast.error('شما در حال استفاده در کامپیوتر هستید، امکان ارسال پیامک با استفاده از کامپیوتر وجود ندارد. لطفا نحوه ارتباط را به حالت اینترنتی تغییر دهید ');
                return false;
            }
            let body = '*' + command + '#';

            if (navigator.userAgent.match(/Android/i)) {
                window.open(`sms://${this.state.cars[this.state.activeCar].phone_device}/?body=${body}`);

            }
            if (navigator.userAgent.match(/iPhone/i)) {
                window.open(`sms://${this.state.cars[this.state.activeCar].phone_device}/&body=${body}`);
            }
        }

    }


    render() {

        return (
            <React.Fragment>
                <Toast/>
                {
                    !this.state.isLoaded && <Loading />
                }
<Actionbar title='تنظیمات اخطار ' noBack={0}/>

                <section className="container-fluid profile-list-items mt-3 pt-5">
                    <div className="row mx-2">
                        <div className="col-12 pt-2 ">
                            <div className="row select-type-box p-3">
                                <div className="col-12 border-bottom pb-2 mb-3">
                                    نوع هشدار
                                </div>
                                <div className="col-6">
                                    <div className={this.state.setting[7] === '3' ? 'type-select-active' : 'type-select'}
                                         onClick={
                                             () => {
                                                 const index = 7;
                                                 const option = 3;
                                                 const command = `SEt${index}${option}`;
                                                 this.sendToSocket(command);
                                                 let newSetting = this.state.setting.substring(0, index) + option + this.state.setting.substring(index+1)

                                                 this.setState({setting: newSetting})
                                             }
                                         }
                                    >
                                        پیامک و تماس
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className={this.state.setting[7] === '2' ? 'type-select-active' : 'type-select'}

                                         onClick={
                                             () => {
                                                 const index = 7;
                                                 const option = 2;
                                                 const command = `SEt${index}${option}`;
                                                 this.sendToSocket(command);
                                                 let newSetting = this.state.setting.substring(0, index) + option + this.state.setting.substring(index+1)

                                                 this.setState({setting: newSetting})
                                             }
                                         }
                                    >
                                         تماس
                                    </div>

                                </div>
                                <div className="col-3">
                                    <div className={this.state.setting[7] === '1' ? 'type-select-active' : 'type-select'}

                                         onClick={
                                             () => {
                                                 const index = 7;
                                                 const option = 1;
                                                 const command = `SEt${index}${option}`;
                                                 this.sendToSocket(command);
                                                 let newSetting = this.state.setting.substring(0, index) + option + this.state.setting.substring(index+1)

                                                 this.setState({setting: newSetting})
                                             }
                                         }
                                    >
                                         پیامک
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="col-12 pt-2 ">
                            <div className="row select-type-box p-3">
                                <div className="col-6 text-end text-small-1">
                                    هشدار باز شدن درب
                                </div>
                                <div className="col-6 ">
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" role="switch"  checked={parseInt(this.state.setting[0])}
                                               onChange={
                                                   () => {
                                                       const index = 0;
                                                       const option = 1 - this.state.setting[index];
                                                       const command = `SEt${index}${option}`;
                                                       this.sendToSocket(command);
                                                       let newSetting = this.state.setting.substring(0, index) + option + this.state.setting.substring(index+1)
                                                       this.setState({setting: newSetting})
                                                   }
                                               }

                                        />
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="col-12 pt-2 ">
                            <div className="row select-type-box p-3">
                                <div className="col-6 text-end text-small-1">
                                    هشدار استارت
                                </div>
                                <div className="col-6 ">
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" role="switch"  checked={parseInt(this.state.setting[1])}
                                               onChange={
                                                   () => {
                                                       const index = 1;
                                                       const option = 1 - this.state.setting[index];
                                                       const command = `SEt${index}${option}`;
                                                       this.sendToSocket(command);
                                                       let newSetting = this.state.setting.substring(0, index) + option + this.state.setting.substring(index+1)
                                                       this.setState({setting: newSetting})
                                                   }
                                               }
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="col-12 pt-2 ">
                            <div className="row select-type-box p-3">
                                <div className="col-6 text-end text-small-1">
                                    هشدار سرقت باتری
                                </div>
                                <div className="col-6 ">
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" role="switch"  checked={parseInt(this.state.setting[2])}

                                               onChange={
                                                   () => {
                                                       const index = 2;
                                                       const option = 1 - this.state.setting[index];
                                                       const command = `SEt${index}${option}`;
                                                       this.sendToSocket(command);
                                                       let newSetting = this.state.setting.substring(0, index) + option + this.state.setting.substring(index+1)
                                                       this.setState({setting: newSetting})
                                                   }
                                               }
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="col-12 pt-2 ">
                            <div className="row select-type-box p-3">
                                <div className="col-6 text-end text-small-2">
                                    هشدار  سرعت غیر مجاز
                                </div>
                                <div className="col-6 ">
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" role="switch"  checked={parseInt(this.state.setting[3])}
                                               onChange={
                                                   () => {
                                                       const index = 3;
                                                       const option = 1 - this.state.setting[index];
                                                       const command = `SEt${index}${option}`;
                                                       this.sendToSocket(command);
                                                       let newSetting = this.state.setting.substring(0, index) + option + this.state.setting.substring(index+1)
                                                       this.setState({setting: newSetting})
                                                   }
                                               }

                                        />
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="col-12 pt-2 ">
                            <div className="row select-type-box p-3">
                                <div className="col-6 text-end text-small-3">
                                    هشدار   جا به جایی با یدک کش
                                </div>
                                <div className="col-6 ">
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" role="switch"  checked={parseInt(this.state.setting[4])}

                                               onChange={
                                                   () => {
                                                       const index = 4;
                                                       const option = 1 - this.state.setting[index];
                                                       const command = `SEt${index}${option}`;
                                                       this.sendToSocket(command);
                                                       let newSetting = this.state.setting.substring(0, index) + option + this.state.setting.substring(index+1)
                                                       this.setState({setting: newSetting})
                                                   }
                                               }
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>

                </section>

            </React.Fragment>
        );
    }
    componentDidMount = () => {
        const mobile = window.localStorage.getItem("mobile");
        const password = window.localStorage.getItem("password");

        API.getCarData(mobile,password)
            .then((response) => {
                this.setState({
                    isLoaded: true,
                    'cars': response.car_act,
                    'setting': response.car_act[this.state.activeCar].Seting
                })
            })

        setTimeout (() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },5)

    }
}

export default NotifConfigs;